import React from 'react';
import {
	Box,
	CircularProgress,
	FormControl,
	FormHelperText,
	FormLabel,
} from '@mui/material';
import { UserEmailSignatureSelect } from '@/components/selects/UserEmailSignatureSelect';

/**
 * Renders the per-email selector for profile signature authoring and keeps the
 * loading indicator colocated with the selector control.
 */
export const ProfileSignatureEmailSelector = ({
	disabled,
	emailOptions,
	isFetchingSignatures,
	onChange,
	selectedEmailOption,
}) => (
	<FormControl fullWidth>
		<FormLabel>Email Signatures</FormLabel>
		<Box sx={{ position: 'relative' }}>
			<UserEmailSignatureSelect
				emailSignatures={emailOptions}
				value={selectedEmailOption}
				disabled={disabled || emailOptions.length === 0}
				loading={isFetchingSignatures}
				onChange={onChange}
			/>
			{isFetchingSignatures && (
				<CircularProgress
					size={24}
					sx={{
						position: 'absolute',
						top: '50%',
						right: 8,
						marginTop: '-12px',
					}}
				/>
			)}
		</Box>
		<FormHelperText sx={{ marginLeft: 1.5 }}>
			Design and save a signature for each email address you send from.
		</FormHelperText>
	</FormControl>
);
